import React from "react";
import "./App.css";

import { AppLayout } from "../layouts/app-layout";

function App() {
  return <AppLayout />;
}

export default App;
